import { createReducer, isAnyOf } from "@reduxjs/toolkit";

import {
  createSubscription,
  createSubscriptionSuccess,
  createSubscriptionFailure,
  createSubscriptionReset,
  getSubscriptionFailure,
  getSubscriptionSuccess,
  getSubscription,
  editSubscriptionSuccess,
  editSubscription,
  getPaymentSubscriptions,
  setPaymentSubscriptionsSuccess,
  setPortionPaymentSubscriptions,
  setPaymentSubscriptionsFailure,
  setPortionPaymentSubscriptionsSuccess,
  setPortionPaymentSubscriptionsFailure,
  getPortionSubscriptions,
  getPortionSubscriptionsSuccess,
  getPortionSubscriptionsFailure,
  getSubscriptionsByPostSuccess,
  getSubscriptionsByPost,
  getSubscriptionsByPostFailure,
  getSubscriptionsByPostReset,
  getSubscriptionDetailsFailure,
  getSubscriptionDetailsSuccess,
  getSubscriptionDetails,
  deleteMySubscription,
  deleteMySubscriptionFailure,
  deleteMySubscriptionSuccess,
  subscriptionsReset,
  changeSubscriptionPosition,
  changeSubscriptionPositionSuccess,
  changeSubscriptionPositionFailure,
  updateSubscriptions,
  editSubscriptionFailure,
  editSubscriptionReset,
} from "./actions";
import {
  setCreatorSubscription,
  setCreatorSubscriptionPortion,
} from "../creatorProfile/actions";

/**
 * @property {number[]} allSubscriptions array of subscription ids
 * @property {object[]} subscriptionById { [subscriptionId]: {subscriptionContent} }
 */
const initialState = {
  allSubscriptions: [],
  purchaseSubscriptions: [],
  subscriptionById: {},
  profileSubscriptionById: {},
  pendingSubscriptions: [],
  nextOffset: undefined,
  totalCount: undefined,
  isLoading: false,
  isEditing: false,
  isEdited: false,
  isCreating: false,
  isCreated: false,
  error: null,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(createSubscription.type, (state) => ({
      ...state,
      isCreating: true,
      error: null,
    }))
    .addCase(createSubscriptionSuccess.type, (state, { payload }) => ({
      ...state,
      isCreating: false,
      isCreated: true,
      profileSubscriptionById: {
        ...state.profileSubscriptionById,
        ...payload.subscriptions,
      },
    }))
    .addCase(createSubscriptionFailure.type, (state, action) => ({
      ...state,
      isCreating: false,
      isCreated: false,
      error: action.payload,
    }))
    .addCase(getSubscription, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(
      getSubscriptionSuccess.type,
      (state, { payload: { subscriptions } }) => ({
        ...state,
        isLoading: false,
        profileSubscriptionById: {
          ...state.profileSubscriptionById,
          ...subscriptions,
        },
      }),
    )
    .addCase(getSubscriptionFailure.type, (state) => ({
      ...state,
      isLoading: false,
    }))
    .addCase(editSubscription.type, (state) => ({
      ...state,
      isEditing: true,
      isEdited: false,
    }))
    .addCase(editSubscriptionSuccess.type, (state, { payload }) => ({
      ...state,
      isEditing: false,
      isEdited: true,
      profileSubscriptionById: {
        ...state.profileSubscriptionById,
        ...payload.subscriptions,
      },
    }))
    .addCase(editSubscriptionFailure.type, (state) => {
      state.isEdited = false;
      state.isEdited = false;
    })
    .addCase(editSubscriptionReset.type, (state) => {
      state.isEdited = false;
      state.isEditing = false;
    })
    .addCase(createSubscriptionReset.type, (state) => {
      state.isCreated = false;
      state.isCreating = false;
    })
    .addCase(getPaymentSubscriptions.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(setPaymentSubscriptionsSuccess.type, (state, { payload }) => {
      const { subscriptionById } = state;
      const { subscriptionById: newSubscriptionById } = payload;

      return {
        ...state,
        subscriptionById: { ...subscriptionById, ...newSubscriptionById },
        error: initialState.error,
        isLoading: false,
      };
    })
    .addCase(setPaymentSubscriptionsFailure.type, (state) => ({
      ...state,
      isLoading: false,
    }))
    .addCase(getPortionSubscriptions, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(getPortionSubscriptionsSuccess.type, (state, { payload }) => {
      const { subscriptions: newSubscriptionById } = payload;

      return {
        ...state,
        profileSubscriptionById: {
          ...state.profileSubscriptionById,
          ...newSubscriptionById,
        },
        error: initialState.error,
        isLoading: false,
      };
    })
    .addCase(getPortionSubscriptionsFailure.type, (state) => ({
      ...state,
      isLoading: false,
    }))
    .addCase(setPortionPaymentSubscriptions.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(
      setPortionPaymentSubscriptionsSuccess.type,
      (state, { payload }) => {
        const { subscriptionById } = state;
        const {
          subscriptionById: newSubscriptionById,
          totalCount,
          nextOffset,
        } = payload;

        return {
          ...state,
          subscriptionById: { ...subscriptionById, ...newSubscriptionById },
          totalCount,
          nextOffset,
          error: initialState.error,
          isLoading: false,
        };
      },
    )
    .addCase(setPortionPaymentSubscriptionsFailure.type, (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false,
    }))
    .addCase(getSubscriptionDetails.type, (state) => ({
      ...state,
    }))
    .addCase(getSubscriptionDetailsSuccess.type, (state, { payload }) => ({
      ...state,
      subscriptionById: {
        ...state.subscriptionById,
        ...payload.subscriptions,
      },
    }))
    .addCase(updateSubscriptions.type, (state, { payload }) => ({
      ...state,
      subscriptionById: {
        ...state.subscriptionById,
        ...payload.subscriptions,
      },
    }))
    .addCase(getSubscriptionDetailsFailure.type, (state, { payload }) => ({
      ...state,
      error: payload,
    }))
    .addCase(getSubscriptionsByPost.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(
      getSubscriptionsByPostSuccess.type,
      (state, { payload: { subscriptions, result } }) => ({
        ...state,
        isLoading: false,
        purchaseSubscriptions: result,
        subscriptionById: {
          ...state.subscriptionById,
          ...subscriptions,
        },
      }),
    )
    .addCase(getSubscriptionsByPostFailure.type, (state) => ({
      ...state,
      purchaseSubscriptions: [],
      isLoading: false,
    }))
    .addCase(getSubscriptionsByPostReset.type, (state) => ({
      ...state,
      purchaseSubscriptions: [],
    }))
    .addCase(deleteMySubscription.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(deleteMySubscriptionSuccess.type, (state) => ({
      ...state,
      isLoading: false,
    }))
    .addCase(deleteMySubscriptionFailure.type, (state) => ({
      ...state,
      isLoading: false,
    }))
    .addCase(subscriptionsReset.type, (state) => ({
      ...initialState,
      profileSubscriptionById: state.profileSubscriptionById,
    }))
    .addCase(changeSubscriptionPosition.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(changeSubscriptionPositionSuccess.type, (state) => ({
      ...state,
      isLoading: false,
    }))
    .addCase(changeSubscriptionPositionFailure.type, (state) => ({
      ...state,
      isLoading: false,
    }))
    .addCase(setCreatorSubscription.type, (state, { payload }) => {
      state.allSubscriptions = payload.subscription;
      state.totalCount = payload.totalCount;
      state.nextOffset = payload.nextOffset;
    })
    .addCase(setCreatorSubscriptionPortion.type, (state, { payload }) => {
      state.totalCount = payload.totalCount;
      state.nextOffset = payload.nextOffset;
      state.allSubscriptions = state.allSubscriptions.concat(
        payload.subscription,
      );
    })
    .addMatcher(
      isAnyOf(editSubscriptionSuccess, createSubscriptionSuccess),
      (state, { payload: { subscriptions } }) => ({
        ...state,
        subscriptionById: { ...state.subscriptionById, ...subscriptions },
      }),
    );
});
